var map = {
	"./3d_design.svg": 80,
	"./EVZ.F_BIG.D.svg": 139,
	"./EVZ.F_BIG.svg": 140,
	"./EVZ.svg": 141,
	"./Evraz_ru.svg": 142,
	"./Memeing.png": 143,
	"./Music.png": 144,
	"./Reading.png": 145,
	"./UPWK.svg": 146,
	"./US.png": 147,
	"./Writing.png": 148,
	"./address_image.svg": 149,
	"./aleks.png": 150,
	"./animated_logo.svg": 151,
	"./blogs_image.svg": 152,
	"./clark.png": 153,
	"./codeInLogo.png": 154,
	"./contactMail.png": 155,
	"./coursera_logo.png": 156,
	"./data_science.svg": 78,
	"./developerActivity.svg": 157,
	"./education.svg": 158,
	"./embedded.svg": 79,
	"./experience.svg": 159,
	"./freecopy_logo.png": 160,
	"./gcp_logo.png": 161,
	"./github_logo.png": 162,
	"./googleAssistant.jpg": 163,
	"./googleAssistant.svg": 164,
	"./google_logo.png": 165,
	"./linkedin.svg": 166,
	"./list.png": 167,
	"./manOnTable.svg": 168,
	"./nextuLogo.jpg": 169,
	"./nptel_logo.png": 170,
	"./portfolio.png": 76,
	"./programmer.svg": 171,
	"./projects_image.svg": 172,
	"./rf.png": 173,
	"./sibsiu.png": 174,
	"./skill.png": 175,
	"./susu.png": 176,
	"./talksCardBack.svg": 177,
	"./talksCardBackAlt.svg": 178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;